import { render } from "./InfoDashboard.vue?vue&type=template&id=d12d7ed6&scoped=true"
import script from "./InfoDashboard.vue?vue&type=script&lang=js"
export * from "./InfoDashboard.vue?vue&type=script&lang=js"

import "./InfoDashboard.vue?vue&type=style&index=0&id=d12d7ed6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12d7ed6"]])

export default __exports__